import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  ViewChild,
  OnChanges,
  SimpleChanges, ElementRef, OnInit, Inject
} from '@angular/core';
import { SingleStepComponent } from './single-step/single-step.component';
import {DOCUMENT, NgForOf, NgIf, NgStyle} from "@angular/common"; // Import the step component

@Component({
  selector: 'app-stepper-slider',
  templateUrl: './stepper-slider.component.html',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    NgStyle
  ],
  styleUrls: ['./stepper-slider.component.scss']
})
export class StepperSliderComponent implements AfterContentInit, OnChanges {
  @ViewChild('mySlider') mySlider: any;
  @ContentChildren(SingleStepComponent) stepComponents: any;

  stepperTitle:any = [];
  @Input() enableTitles = false;
  @Input() currentStep: any = 0;
  @Input() idPrefix: any = 1;

  constructor(
      @Inject(DOCUMENT) private dom) {
  }
  ngAfterContentInit() {
    let lengthOfSteps = this.stepComponents.length;
    this.stepComponents.forEach((stepComponent, index) => {
      // Access each step component using stepComponent
      // Index gives you the position of the step
      stepComponent.percentOfOneSection = (100 / lengthOfSteps);
      this.stepperTitle[index] = {
        title: stepComponent.title,
        icon: stepComponent.icon
      }
    });
  }

  setCurrentStep(index:any){
    this.currentStep = index;
    setTimeout(()=>{
      let item = this.dom.getElementById('mySlider_' + this.idPrefix);
      if(item){
        item.style.left = (-100 * index) + '%';
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentStep']){
      this.setCurrentStep(changes['currentStep'].currentValue);
    }
  }



}
